import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=47e1ef9a&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
import style0 from "./Hero.scss?vue&type=style&index=0&id=47e1ef9a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1ef9a",
  null
  
)

export default component.exports